<template>
  <div
    class="modal fade"
    id="releaseTicketsModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="releaseTicketsModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="releaseTicketsModalLabel">
            <i class="fas fa-code-branch mr-2"></i>
            <span v-if="release">
              {{ release.version_string }} — {{ release.name }}
            </span>
            <span v-else>Chamados da Release</span>
          </h5>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <!-- Loading -->
          <div v-if="loading" class="text-center py-4">
            <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
          </div>

          <template v-else>
            <!-- Release info card -->
            <div
              v-if="releaseDetail"
              class="card mb-3"
              style="border-left: 4px solid #4265ff"
            >
              <div class="card-body py-2 px-3">
                <div class="row">
                  <div class="col-md-3 col-6 mb-1">
                    <small class="text-muted d-block">Status</small>
                    <span
                      :class="statusClass(releaseDetail.status)"
                      style="font-size: 12px"
                    >
                      {{ statusLabel(releaseDetail.status) }}
                    </span>
                  </div>
                  <div class="col-md-3 col-6 mb-1" v-if="releaseDetail.project">
                    <small class="text-muted d-block">Projeto</small>
                    <strong>{{ releaseDetail.project.name }}</strong>
                  </div>
                  <div class="col-md-3 col-6 mb-1" v-if="releaseDetail.relator">
                    <small class="text-muted d-block">Relator</small>
                    <span>{{ releaseDetail.relator.name }}</span>
                  </div>
                  <div class="col-md-3 col-6 mb-1" v-if="releaseDetail.po">
                    <small class="text-muted d-block">PO</small>
                    <span>{{ releaseDetail.po.name }}</span>
                  </div>
                  <div
                    class="col-md-3 col-6 mb-1"
                    v-if="releaseDetail.data_fim_desenvolvimento_f"
                  >
                    <small class="text-muted d-block"
                      >Fim Desenvolvimento</small
                    >
                    <span>{{ releaseDetail.data_fim_desenvolvimento_f }}</span>
                  </div>
                  <div
                    class="col-md-3 col-6 mb-1"
                    v-if="releaseDetail.data_prevista_inicio_testes_f"
                  >
                    <small class="text-muted d-block">Início Testes</small>
                    <span>{{
                      releaseDetail.data_prevista_inicio_testes_f
                    }}</span>
                  </div>
                  <div
                    class="col-md-3 col-6 mb-1"
                    v-if="releaseDetail.data_fim_testes_f"
                  >
                    <small class="text-muted d-block">Fim Testes</small>
                    <span>{{ releaseDetail.data_fim_testes_f }}</span>
                  </div>
                  <div
                    class="col-md-3 col-6 mb-1"
                    v-if="releaseDetail.programacao_inicial_deploy_f"
                  >
                    <small class="text-muted d-block">Deploy Previsto</small>
                    <span>{{
                      releaseDetail.programacao_inicial_deploy_f
                    }}</span>
                  </div>
                  <div
                    class="col-md-3 col-6 mb-1"
                    v-if="releaseDetail.data_fechamento_release_f"
                  >
                    <small class="text-muted d-block">Fechamento</small>
                    <span>{{ releaseDetail.data_fechamento_release_f }}</span>
                  </div>
                  <div
                    class="col-md-12 mb-1"
                    v-if="releaseDetail.qaUsers && releaseDetail.qaUsers.length"
                  >
                    <small class="text-muted d-block">QA</small>
                    <span
                      v-for="u in releaseDetail.qaUsers"
                      :key="u.id"
                      class="badge badge-light border mr-1"
                      >{{ u.name }}</span
                    >
                  </div>
                  <div
                    class="col-md-12 mb-1"
                    v-if="
                      releaseDetail.devUsers && releaseDetail.devUsers.length
                    "
                  >
                    <small class="text-muted d-block">Desenvolvedores</small>
                    <span
                      v-for="u in releaseDetail.devUsers"
                      :key="u.id"
                      class="badge badge-light border mr-1"
                      >{{ u.name }}</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <!-- Tickets table -->
            <div
              v-if="tickets.length === 0"
              class="text-center text-muted py-3"
            >
              <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
              Nenhum chamado vinculado a esta release.
            </div>

            <div v-else class="table-responsive">
              <table class="table table-sm table-hover mb-0">
                <thead class="thead-light">
                  <tr>
                    <th style="width: 80px">#ID</th>
                    <th>Título</th>
                    <th style="width: 150px">Status</th>
                    <th style="width: 140px">Projeto</th>
                    <th style="width: 160px">Responsável</th>
                    <th style="width: 50px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="ticket in tickets" :key="ticket.id">
                    <td class="align-middle">
                      <strong>#{{ ticket.id }}</strong>
                    </td>
                    <td class="align-middle">{{ ticket.title }}</td>
                    <td class="align-middle">
                      <span
                        v-if="ticket.status_calls"
                        :class="ticket.status_calls.badge_description"
                        style="font-size: 11px"
                      >
                        {{ ticket.status_calls.description }}
                      </span>
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td class="align-middle">
                      <span v-if="ticket.project">{{
                        ticket.project.name
                      }}</span>
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td class="align-middle">
                      <span v-if="ticket.dev">{{ ticket.dev.name }}</span>
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link
                        :to="'/calls/ticket/' + ticket.id"
                        class="btn btn-crud view btn-sm"
                        title="Visualizar chamado"
                        @click.native="hide"
                      >
                        <i class="fas fa-eye"></i>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>

        <div class="modal-footer">
          <span class="text-muted mr-auto" v-if="!loading && tickets.length">
            {{ tickets.length }} chamado{{
              tickets.length !== 1 ? "s" : ""
            }}
            vinculado{{ tickets.length !== 1 ? "s" : "" }}
          </span>
          <router-link
            v-if="releaseDetail"
            :to="
              '/projects/' +
              releaseDetail.project_id +
              '/releases/view/' +
              releaseDetail.id
            "
            class="btn btn-primary"
            @click.native="hide"
          >
            <i class="fas fa-external-link-alt mr-1"></i> Ver Release
          </router-link>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const STATUS_MAP = {
  planejada: { label: "Planejada", cls: "badge badge-secondary" },
  em_desenvolvimento: { label: "Em Desenvolvimento", cls: "badge badge-info" },
  em_testes: { label: "Em Testes", cls: "badge badge-warning" },
  fechada: { label: "Fechada", cls: "badge badge-danger" },
  finalizada: { label: "Finalizada", cls: "badge badge-success" },
};

export default {
  name: "ReleaseTicketsModal",

  data() {
    return {
      release: null,
      releaseDetail: null,
      tickets: [],
      loading: false,
    };
  },

  methods: {
    statusLabel(s) {
      return STATUS_MAP[s] ? STATUS_MAP[s].label : s;
    },

    statusClass(s) {
      return STATUS_MAP[s] ? STATUS_MAP[s].cls : "badge badge-secondary";
    },

    open(release) {
      this.release = release;
      this.releaseDetail = null;
      this.tickets = [];
      this.loading = true;
      $("#releaseTicketsModal").modal("show");

      const api = this.$store.state.api;

      Promise.all([
        axios.get(api + "releases/" + release.id),
        axios.get(api + "releases/" + release.id + "/tickets"),
      ])
        .then(([detailRes, ticketsRes]) => {
          this.releaseDetail = detailRes.data;
          this.tickets = ticketsRes.data.data || [];
        })
        .catch(() => {
          this.tickets = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    hide() {
      $("#releaseTicketsModal").modal("hide");
      $("body").removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
  },
};
</script>
